import '../assets/css/HtmlCssSection.css'
import Navbar from './NavBar.js'
import HtmlCssSection from './HtmlCssSection'
import FoooterTiles from './FooterSection'
import Fade from 'react-reveal/Fade';

function Projects() {
  return (
    <div className="htmlCssSection">
      <Navbar />
      <div className="sec9 container">
        <h1>Html Css Challenge</h1>
        <h3>All below shapes are made using HTML CSS only 
          <span><a href='https://github.com/nooras/html-css-challenge'><button>Source Code</button></a></span></h3>
        
        <div className="row designSection">
          <HtmlCssSection />
        </div>
      </div>
      <Fade left>
        <section>
          <FoooterTiles />
        </section>
      </Fade>
    </div>
  );
}

export default Projects;
